export const queryKeys = {
  settings: {
    all: ['settings'],
    account: () => [...queryKeys.settings.all, 'account'],
    global: () => [...queryKeys.settings.all, 'global'],
  },
  costs: {
    all: ['costs'],
    summary: (range: string) => [...queryKeys.costs.all, 'summary', range],
    daily: (range: string) => [...queryKeys.costs.all, 'daily', range],
    byProject: (range: string) => [...queryKeys.costs.all, 'byProject', range],
    history: (limit: number, offset: number) => [...queryKeys.costs.all, 'history', limit, offset],
  },
  media: {
    all: ['media'],
    list: (filters: Record<string, unknown>) => [...queryKeys.media.all, 'list', filters],
  },
  projects: {
    all: ['projects'],
    list: (filters: Record<string, unknown>) => [...queryKeys.projects.all, 'list', filters],
  },
  dedicatedModels: {
    all: ['dedicatedModels'],
    list: () => [...queryKeys.dedicatedModels.all, 'list'],
  },
  activity: {
    all: ['activity'],
    list: (filters: Record<string, unknown>) => [...queryKeys.activity.all, 'list', filters],
  },
  admin: {
    all: ['admin'],
    activity: (filters: Record<string, unknown>) => [...queryKeys.admin.all, 'activity', filters],
    accounts: () => [...queryKeys.admin.all, 'accounts'],
    statsSummary: () => [...queryKeys.admin.all, 'stats', 'summary'],
    statsUsers: (range: string) => [...queryKeys.admin.all, 'stats', 'users', range],
    statsDaily: (range: string) => [...queryKeys.admin.all, 'stats', 'daily', range],
    users: (params: Record<string, unknown>) => [...queryKeys.admin.all, 'users', params],
    campaigns: () => [...queryKeys.admin.all, 'campaigns'],
    renderStats: () => [...queryKeys.admin.all, 'render-stats'],
    storage: () => [...queryKeys.admin.all, 'storage'],
  },
  credits: {
    all: ['credits'],
    balance: () => [...queryKeys.credits.all, 'balance'],
  },
  referrals: {
    all: ['referrals'],
    info: () => [...queryKeys.referrals.all, 'info'],
  },
  tips: {
    all: () => ['tips'] as const,
    admin: () => ['tips', 'admin'] as const,
  },
}
